import React from 'react';

import FooterLayoutComponent from '../common/layout/FooterLayoutComponent';
import PaginationComponent from '../common/bbs/PaginationComponent';
import { Link } from 'react-router-dom';

const StoryListComponent = props => {
    const { list, paginationObj, onClickArticle, onClickBtnPageNum } = props;
    return (
        <main className="story-news">
            <div className="body">
                <div className="head">
                    <div className="title">
                        STORIES & NEWS
                            </div>
                    <nav className="lnb">
                        <ul>
                            <li className='on'>
                                <Link
                                    to='/story'>STORY
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to='/news'>NEWS
                                </Link>
                            </li>
                        </ul>
                    </nav>
                </div>
                <section className="bbs-list">
                    <div className="list">
                        <ul>
                            {list.map((item, idx) =>
                                <li key={idx}>
                                    <div
                                        onClick={evt => onClickArticle(item.id)}
                                        className="item">
                                        <div className="img">
                                            <img
                                                src={item.imageObj.url}
                                                alt={item.subject}
                                            />
                                        </div>
                                        <div className="info">
                                            <div className="subject">{item.subject}</div>
                                            <div className="desc">
                                                {item.context.slice(0, 350)}
                                                {(item.context.length > 350 ? "..." : "")}
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>
                    <PaginationComponent
                        onClickBtnPageNum={onClickBtnPageNum}
                        paginationObj={paginationObj} />
                </section>
            </div>
            <FooterLayoutComponent
                {...props} />
        </main>
    )
}

export default StoryListComponent;